import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CHART_COLORS = [
    "#2b6cb0",
    "#38a169",
    "#d69e2e",
    "#dd6b20",
    "#805ad5",
    "#319795",
    "#e53e3e",
    "#3182ce",
    "#718096",
    "#b83280",
];

const sectionIdFromKey = (key) => {
    const value = String(key || "").toLowerCase();
    if (value === "notes")
        return "notes";
    if (value === "systematicreviews")
        return "systematic-reviews";
    if (!value)
        return null;
    return `type:${key}`;
};

const WatchlistContentChart = ({ contentCounts = [], onCategoryClick }) => {
    const options = useMemo(() => {
        const rows = (Array.isArray(contentCounts) ? contentCounts : []).filter((row) => {
            const key = String(row?.Key || "").toLowerCase();
            return key !== "notes" && key !== "systematicreviews";
        });
        const categories = rows.map((row) => row.Label || row.Key || "");
        const data = rows.map((row, index) => ({
            y: Number(row.Count) || 0,
            color: CHART_COLORS[index % CHART_COLORS.length],
            custom: {
                key: row.Key,
                sectionId: sectionIdFromKey(row.Key),
            },
        }));

        return {
            chart: {
                type: "column",
                height: 280,
                backgroundColor: "transparent",
            },
            title: {
                text: "Watchlist contents",
                align: "left",
                style: {
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#1a202c",
                },
            },
            xAxis: {
                categories,
                labels: {
                    style: {
                        fontSize: "11px",
                        color: "#4a5568",
                    },
                },
            },
            yAxis: {
                min: 0,
                allowDecimals: false,
                title: {
                    text: null,
                },
                labels: {
                    style: {
                        color: "#718096",
                    },
                },
            },
            legend: {
                enabled: false,
            },
            tooltip: {
                pointFormat: "<b>{point.y}</b> item(s)",
            },
            plotOptions: {
                column: {
                    borderRadius: 3,
                    pointPadding: 0.15,
                    groupPadding: 0.1,
                    cursor: "pointer",
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontSize: "11px",
                            fontWeight: "600",
                            textOutline: "none",
                            color: "#2d3748",
                        },
                    },
                    point: {
                        events: {
                            click: function () {
                                const sectionId = this.options?.custom?.sectionId;
                                if (sectionId && onCategoryClick)
                                    onCategoryClick(sectionId);
                            },
                        },
                    },
                },
            },
            series: [
                {
                    name: "Items",
                    data,
                },
            ],
            credits: {
                enabled: false,
            },
            exporting: {
                enabled: false,
            },
        };
    }, [contentCounts, onCategoryClick]);

    if (!Array.isArray(contentCounts) || contentCounts.length === 0) {
        return (
            <div className="watchlists-content-chart-empty">
                No content counts yet
            </div>
        );
    }

    return (
        <div className="watchlists-content-chart">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default WatchlistContentChart;
